<template>
  <div class="add">
    <div class="title">
      <a-icon class="btn_back" theme="twoTone" type="left-circle" @click="$router.go(-1)" />
      <h2 class="name">租客/{{ formTitle }}</h2>
      <!-- <a-icon type="left-circle" style="font-size: 20px; margin-left: 10px" @click="reback" /> -->
    </div>

    <div class="content">
      <!-- 核心信息 -->
      <MainInfo ref="ruleForm" :form="form" :rules="rules" :sexOptions="sexOptions" @addPhone="addPhone" @searchBtn="searchBtn" />
      <!-- <a-form-model ref="ruleForm" :model="form.lesseeInfoBo" :rules="rules">
        <h3 class="label">核心信息</h3>
        <a-row>
          <a-col class="mr30" :span="4">
            <a-form-model-item label="客户姓名" prop="lesseeName" :colon="false">
              <a-input placeholder="客户姓名" v-model="form.lesseeInfoBo.lesseeName" :maxLength="16" />
            </a-form-model-item>
          </a-col>

          <a-col class="mr30" :span="4">
            <a-form-model-item label="客户电话" prop="lesseePhone" :colon="false">
              <a-input
                :maxLength="11"
                placeholder="客户电话"
                v-model="form.lesseeInfoBo.lesseePhone"
                @blur="searchBtn(form.lesseeInfoBo.lesseePhone)"
              />
            </a-form-model-item>
          </a-col>

          <a-col class="mr30" :span="4">
            <a-form-model-item label="微信" :colon="false">
              <a-input placeholder="微信" v-model="form.lesseeInfoBo.lesseeWechat" :maxLength="11" />
            </a-form-model-item>
          </a-col>

          <a-col class="mr30" :span="4">
            <a-form-model-item label="性别" :colon="false">
              <a-select placeholder="请选择" v-model="form.lesseeInfoBo.lesseeSex">
                <a-select-option v-for="item in sexOptions" :value="item.dictValue" :key="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col class="mr30" :span="4">
            <a-form-model-item label=" " :colon="false">
              <a-button @click="isAlternatePhone = true">+添加备用电话</a-button>
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model> -->

      <!-- 备用电话 -->
      <a-form-model v-if="isAlternatePhone" :model="alternatePhone" :rules="rules">
        <a-row>
          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="备用电话一" prop="phone1">
              <a-input v-model="alternatePhone.phone1" :maxLength="11" placeholder="备用电话一" @blur="searchBtn(alternatePhone.phone1)" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="备用电话二" prop="phone2">
              <a-input v-model="alternatePhone.phone2" :maxLength="11" placeholder="备用电话二" @blur="searchBtn(alternatePhone.phone2)" />
            </a-form-model-item>
          </a-col>
          <a-col :span="4" class="mr30">
            <a-form-model-item :colon="false" label="备用电话三" prop="phone3">
              <a-input v-model="alternatePhone.phone3" :maxLength="11" placeholder="备用电话三" @blur="searchBtn(alternatePhone.phone3)" />
            </a-form-model-item>
          </a-col>
        </a-row>
      </a-form-model>

      <!-- <a-form-model>
        <a-form-model-item label="是否存在客户" :colon="false">
          <a-button @click="searchBtn">查询</a-button>
        </a-form-model-item>
      </a-form-model> -->

      <a-divider />

      <!-- 需求信息 -->
      <a-form-model ref="ruleForm2" :model="form" :rules="rules">
        <!--
        :label-col="{ span: 24, offset: 0 }"
        :wrapper-col="{ span: 24,offset:0 }"
        -->
        <h3 class="label">需求信息</h3>
        <a-row>
          <!-- 需求面积和租金改为必填和提到品牌信息之前 -->
          <a-col :span="6" class="">
            <span style="display: flex">
              <a-form-model-item :colon="false" label="需求面积" prop="requirementAreaStart">
                <a-input
                  v-model="form.requirementAreaStart"
                  :maxLength="10"
                  class="w95"
                  placeholder="起始"
                  suffix="m²"
                  @input="intValidate('requirementAreaStart')"
                />
              </a-form-model-item>
              <a-form-model-item :colon="false" label=" ">
                <div>&nbsp;-&nbsp;</div>
              </a-form-model-item>
              <a-form-model-item :colon="false" label=" " prop="requirementAreaEnd">
                <a-input
                  v-model="form.requirementAreaEnd"
                  :maxLength="10"
                  class="w95"
                  placeholder="结束"
                  suffix="m²"
                  @input="intValidate('requirementAreaEnd')"
                />
              </a-form-model-item>
            </span>
          </a-col>
          <!-- 租金 -->
          <a-col :span="6" class="">
            <span style="display: flex">
              <a-form-model-item :colon="false" label="租金（元/月）" prop="rentExpenseStart">
                <a-input v-model="form.rentExpenseStart" :maxLength="10" class="w95" placeholder="起始" @input="intValidate('rentExpenseStart')" />
              </a-form-model-item>
              <a-form-model-item :colon="false" label=" ">
                <div>&nbsp;-&nbsp;</div>
              </a-form-model-item>
              <a-form-model-item :colon="false" label=" " prop="rentExpenseEnd">
                <a-input v-model="form.rentExpenseEnd" :maxLength="10" class="w95" placeholder="结束" @input="intValidate('rentExpenseEnd')" />
              </a-form-model-item>
              <!-- <span style="position: absolute; top: 50px; right: -36px">元/月</span> -->
            </span>
          </a-col>
          <a-col :span="6" class="">
            <a-form-model-item :colon="false" class="w200" label="品牌名称">
              <a-input v-model="form.brandName" :maxLength="11" placeholder="品牌名称" />
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-top: 20px">
          <a-col :span="6" class="">
            <a-form-model-item :colon="false" label="经营行业" prop="industryCategoryId" style="float: left">
              <span style="display: flex; margin-top: 4px">
                <a-select
                  v-model="form.industryCategoryId"
                  :filter-option="filterOption"
                  allowClear
                  class="w150"
                  defaultValue=""
                  placeholder="全部大类"
                  show-search
                  @change="getIndustryCategoryName"
                >
                  <a-select-option v-for="item in industryCategory" :key="item.id" :value="item.id">{{ item.industryCategoryName }}</a-select-option>
                </a-select>
                &nbsp;&nbsp;
              </span>
            </a-form-model-item>
            <a-form-model-item :colon="false" label="业态细分" prop="industrySubclassId" style="float: left">
              <a-select
                v-model="form.industrySubclassId"
                :filter-option="filterOption"
                allowClear
                class="w150"
                defaultValue=""
                placeholder="全部子类"
                show-search
                @change="getIndustrySubclassName"
              >
                <a-select-option v-for="item in industrySubclass" :key="item.id" :value="item.id">{{ item.industryCategoryName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="6" class="">
            <a-form-model-item :colon="false" class="w200" label="需求商铺类型" prop="storeTypeId">
              <a-select v-model="form.storeTypeId" mode="multiple" placeholder="请选择">
                <a-select-option v-for="item in typeOptions" :key="item.dictValue" :value="item.dictValue.toString()">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <a-col :span="6" class="">
            <a-form-model-item :colon="false" label="商铺性质">
              <a-select v-model="form.shopNatureId" class="w200" defaultValue="" placeholder="全部">
                <a-select-option key="shopNatureId0" value="">全部</a-select-option>
                <a-select-option v-for="item in natureOptions" :key="item.dictValue" :value="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- <a-col class="" :span="6">
            <a-form-model-item class="w200" label="是否临街" :colon="false" prop="isFrontage">
              <a-select placeholder="请选择" v-model="form.isFrontage">
                <a-select-option :value="item.dictValue" v-for="item in isOptions" :key="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col> -->

          <!-- <a-col class="mr30" :span="4">
            <a-form-model-item label="经营状态" :colon="false">
              <a-select placeholder="请选择" v-model="form.operatingStateId">
                <a-select-option :value="item.dictValue" v-for="item in statusOptions" :key="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col> -->
        </a-row>

        <a-row style="margin-top: 20px">
          <a-col :span="6">
            <a-form-model-item :colon="false" class="w200" label="区域">
              <!-- <a-select placeholder="区域" v-model="form.districtName" @change="regionChange">
                <a-select-option :value="item.districtFullName" v-for="item in district" :key="item.id">
                  {{ item.districtFullName }}
                </a-select-option>
              </a-select> -->
              <a-select v-model="form.districtId" mode="multiple" placeholder="区域" @change="regionChangeV2($event)">
                <a-select-option v-for="item in region" :key="item.areaId" :value="item.areaId">{{ item.areaName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item :colon="false" class="w200" label="商圈">
              <a-select
                v-model="form.businessDistrictId"
                :default-active-first-option="false"
                :filter-option="false"
                :not-found-content="null"
                :show-arrow="true"
                mode="multiple"
                placeholder="商圈"
                show-search
                @change="businessDistrictMethodV2($event)"
              >
                <!--  @search="businessDisSearch"              -->
                <a-select-option v-for="item in businessDistrict" :key="item.id" :value="item.id">{{ item.businessDistrictName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>

          <a-col :span="6">
            <a-form-model-item :colon="false" class="w200" label="街道">
              <a-select
                v-model="form.streetId"
                :default-active-first-option="false"
                :filter-option="false"
                :not-found-content="null"
                :show-arrow="true"
                mode="multiple"
                placeholder="街道"
                show-search
                @change="StreetMethod($event, 'addRentTourist')"
                @search="streetSearch"
              >
                <a-select-option v-for="item in StreetData" :key="item.id" :value="item.id">{{ item.streetFullName }}</a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
          <!-- 隐藏是否餐饮 -->
          <!-- <a-col :span="6" style="display:flex;">
            <a-form-model-item label="是否餐饮" class="w95" :colon="false" prop="isCatering">
              <a-select v-model="form.isCatering" placeholder="请选择" @select="isCateringSelect">
                <a-select-option :value="item.dictValue" v-for="item in isOptions" :key="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
            &nbsp;&nbsp;
            <a-form-model-item label="类型" class="w95" :colon="false" prop="alloweCateringTypeId">
              <a-select placeholder="请选择" v-model="form.alloweCateringTypeId">
                <a-select-option :value="item.dictValue" v-for="item in food" :key="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col> -->
        </a-row>

        <a-row style="margin-top: 20px">
          <a-col :span="6" class="">
            <a-form-model-item :colon="false" label="面宽" prop="floorWide">
              <div style="display: flex">
                <a-input
                  v-model="form.floorWideStart"
                  :maxLength="10"
                  class="w95"
                  placeholder="起始"
                  suffix="m"
                  @input="intValidate('floorWideStart')"
                />
                &nbsp;-&nbsp;
                <a-input v-model="form.floorWideEnd" :maxLength="10" class="w95" placeholder="结束" suffix="m" @input="intValidate('floorWideEnd')" />
              </div>
            </a-form-model-item>
          </a-col>

          <a-col :span="6" class="">
            <a-form-model-item :colon="false" label="层高" prop="floorHigh">
              <div style="display: flex">
                <a-input
                  v-model="form.floorHighStart"
                  :maxLength="5"
                  class="w95"
                  placeholder="层高"
                  suffix="m"
                  @input="intValidate('floorHighStart')"
                />
                &nbsp;-&nbsp;
                <a-input v-model="form.floorHighEnd" :maxLength="5" class="w95" placeholder="结束" suffix="m" @input="intValidate('floorHighEnd')" />
              </div>
            </a-form-model-item>
          </a-col>

          <a-col :span="6" class="">
            <a-form-model-item :colon="false" label="进深" prop="floorLong">
              <div style="display: flex">
                <a-input
                  v-model="form.floorLongStart"
                  :maxLength="5"
                  class="w95"
                  placeholder="进深"
                  suffix="m"
                  @input="intValidate('floorLongStart')"
                />
                &nbsp;-&nbsp;
                <a-input v-model="form.floorLongEnd" :maxLength="5" class="w95" placeholder="结束" suffix="m" @input="intValidate('floorLongEnd')" />
              </div>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row style="margin-top: 20px">
          <a-col :span="6" class="">
            <span style="display: flex">
              <a-form-model-item :colon="false" label="楼层" prop="floorStart">
                <a-input v-model="form.floorStart" :maxLength="2" class="w95" placeholder="起始" suffix="层" @input="intValidate('floorStart')" />
              </a-form-model-item>
              <a-form-model-item :colon="false" label=" " prop="floorStart">
                <div>&nbsp;-&nbsp;</div>
              </a-form-model-item>
              <a-form-model-item :colon="false" label=" " prop="floorEnd">
                <a-input v-model="form.floorEnd" :maxLength="2" class="w95" placeholder="结束" suffix="层" @input="intValidate('floorEnd')" />
              </a-form-model-item>
            </span>
          </a-col>

          <a-col :span="6" class="">
            <a-form-model-item :colon="false" label="是否接受转让费" prop="isHaveTransferFee">
              <a-select v-model="form.isHaveTransferFee" class="w200" defaultValue="" placeholder="请选择">
                <a-select-option key="isHaveTransferFee0" value="">全部</a-select-option>
                <a-select-option v-for="item in isOptions" :key="item.dictValue" :value="item.dictValue">
                  {{ item.dictLabel }}
                </a-select-option>
              </a-select>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-top: 20px">
          <a-form-model-item :colon="false" label="商铺配套">
            <a-checkbox-group v-model="shopAncillaryArr">
              <a-checkbox v-for="item in shopAncillaryOpts" :key="item.dictValue" :value="item.dictLabel" style="margin-bottom: 20px">
                {{ item.dictLabel }}
              </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
        </a-row>
        <a-row class="checkrow">
          <a-col :span="24">
            <a-form-model-item label="消费配套">
              <a-checkbox-group v-model="form.consumeAncillaryIds" @change="consumeAncillaryChange">
                <a-checkbox v-for="item in consumeAncillaryOpts" :key="item.dictValue" :value="item.dictValue">
                  {{ item.dictLabel }}
                </a-checkbox>
              </a-checkbox-group>
            </a-form-model-item>
          </a-col>
        </a-row>
        <a-row style="margin-top: 20px">
          <a-form-model-item :colon="false" label="自定义标签">
            <a-checkbox-group v-model="customTags">
              <a-checkbox v-for="item in customTagList" :key="item.id" :value="item.tagName" name="type">
                {{ item.tagName }}
              </a-checkbox>
            </a-checkbox-group>
          </a-form-model-item>
        </a-row>
        <a-divider />
        <h3 class="label">其他信息</h3>
        <textarea v-model="form.otherInfo" class="textarea" placeholder="请输入备注信息"></textarea>
      </a-form-model>
    </div>
    <div style="text-align: center; margin-bottom: 100px">
      <a-button :disabled="isExists" class="el_button el-button--primary touristBtn" size="large" @click="addtourist">
        {{ this.$route.query.id >= 0 ? '保存' : '提交' }}
      </a-button>
    </div>
    <a-modal v-model="phoneRepeatVisible" :footer="null" on-ok="handleOk" title="温馨提示">
      <p class="">
        我的客源已经存在该号码：
        <a @click="goTouristDetail()">{{ curRepeatPhone }}</a>
        ,请前往查看!!!
      </p>
    </a-modal>
  </div>
</template>

<script>
import touristApi from '@/api/system/tourist/tourist.js';
import { singleSelectMixin } from '@/mixin/singleSelect';
import MainInfo from './components/addForm/mainInfo.vue';
import beforeRouteLeaveMixin from '@/mixin/beforeRouteLeave';
import locationApi from '@/api/location.js';

export default {
  name: 'TouristAdd',
  components: { MainInfo },

  mixins: [singleSelectMixin, beforeRouteLeaveMixin],
  data() {
    // 电话号码正则
    const validatePhone = async (rule, value, callback) => {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value === undefined || value === '') {
        callback();
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确格式的手机号码!'));
      } else {
        callback();
      }
    };
    // 数字正则
    const validateNumber = (rule, value, callback) => {
      const reg = /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/;
      if (value === undefined || value === '' || value === null) {
        callback();
      } else if (!reg.test(value)) {
        console.log(value, '来自数字正则打印');
        callback(new Error('格式不正确！'));
      } else {
        callback();
      }
    };
    return {
      phoneRepeatVisible: false,
      curRepeatLesseeInfoId: '',
      curRepeatPhone: '',
      form: {
        channelResource: '1',
        alloweCateringTypeId: undefined,
        brandName: undefined,
        businessDistrictId: [],
        businessDistrictName: [],
        districtId: [],
        districtName: [],
        electricPower: '', // 电功率
        floorEnd: '',
        floorHigh: '',
        floorLong: '',
        floorStart: '',
        floorWide: '',
        floorWideStart: '',
        floorWideEnd: '',
        floorLongStart: '',
        floorLongEnd: '',
        floorHighStart: '',
        floorHighEnd: '',

        gasCapacity: '', // 天然气容量
        ifEscalator: 'N',
        ifNetwork: 'N',
        industryCategoryName: undefined,
        industrySubclassName: undefined,
        industryCategoryId: undefined, //	行业分类 字典表类型：industry_category
        industrySubclassId: undefined, //	经营行业 字典表类型：industry_subclass
        isCanNakedLight: 'N',
        isCatering: undefined,
        isEjectSmoke: 'N',
        isElevator: 'N',
        isFrontage: undefined,
        isGas: 'N',
        isOfficePass: 'N',
        isOtherPass: 'N',
        isOutsideArea: 'N',
        isParkingSpace: 'N',
        isPassengerLift: 'N',
        isPower: 'N',
        isResidentsPass: 'N',
        isSewageDisposal: 'N',
        isSewerSystem: 'N',
        isStudentsPass: 'N',
        isTouristPass: 'N',
        isWaterworks: 'N',
        lesseeInfoBo: {
          alternatePhone: '', // 备用手机号（最多三个），逗号隔开
          lesseeName: '',
          lesseePhone: '',
          lesseeSex: undefined,
          lesseeWechat: '',
          id: '',
          rentSaleType: '1'
        },
        operatingStateId: undefined,
        otherInfo: undefined,
        rentExpenseEnd: '',
        rentExpenseStart: '',
        requirementAreaEnd: '',
        requirementAreaStart: '',
        shopNatureId: undefined,
        storeTypeId: [],
        streetId: [],
        streetName: [],
        tagsContentArray: undefined,
        tagsIdArray: undefined,
        trafficCrowd: '',
        shopAncillary: '',
        isHaveTransferFee: '', // 是否有转让费 字典表类型：sys_yes_no
        consumeAncillaryArr: [],
        consumeAncillaryIds: [], // 消费配套IDs
        consumeAncillary: undefined // 消费配套，多个之间用逗号隔开
      },

      rules: {
        lesseeName: [
          { required: true, message: '请输入姓名', trigger: 'blur' },
          { min: 1, max: 16, message: '姓名格式不正确', trigger: 'blur' }
        ],
        lesseePhone: [
          { required: true, message: '请输入电话号码', trigger: 'blur' },
          { validator: validatePhone, trigger: 'blur' }
        ],
        lesseeSex: [{ required: true, message: '请选择性别', trigger: 'change' }],
        industryCategoryId: [{ required: true, message: '请选择经营行业', trigger: 'change' }],
        storeTypeId: [{ required: true, message: '请选择商铺类型', trigger: 'change' }],
        industrySubclassId: [{ required: true, message: '请选择经营行业小类', trigger: 'change' }],
        requirementAreaEnd: [
          { required: true, message: '请输入需求面积', trigger: 'blur' },
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'change'
          },
          {
            validator: this.requirementAreaEndRule,
            trigger: 'blur' // 结束的需求面积验证
          }
        ],
        requirementAreaStart: [
          { required: true, message: '请输入需求面积', trigger: 'blur' },
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          {
            // validator: this.requirementAreaStartRule,
            validator: this.requirementAreaEndRule,
            trigger: 'blur' // 开始的需求面积验证
          }
        ],
        rentExpenseStart: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { required: true, message: '请输入租金', trigger: 'blur' }
        ],
        rentExpenseEnd: [
          {
            pattern: /^((([0-9]+)|([1-9][0-9]*))(.[0-9]{0,2}){0,1})$/,
            message: '格式错误',
            trigger: 'blur'
          },
          { required: true, message: '请输入租金', trigger: 'blur' },
          {
            validator: this.rentExpenseEndRule,
            trigger: 'blur' // 开始的需求面积验证
          }
        ],
        isHaveTransferFee: [{ required: false, message: '必填', trigger: 'blur' }],
        phone1: [{ validator: validatePhone, trigger: 'blur' }],
        phone2: [{ validator: validatePhone, trigger: 'blur' }],
        phone3: [{ validator: validatePhone, trigger: 'blur' }],
        floorWide: [
          { validator: validateNumber, trigger: 'blur' },
          { validator: this.floorWideRule, trigger: 'blur' }
        ],
        floorHigh: [
          { validator: validateNumber, trigger: 'blur' },
          { validator: this.floorHighRule, trigger: 'blur' }
        ],
        floorLong: [
          { validator: validateNumber, trigger: 'blur' },
          {
            validator: this.floorLongRule,
            trigger: 'blur'
          }
        ],
        floorStart: [{ validator: validateNumber, trigger: 'blur' }],
        floorEnd: [
          { validator: validateNumber, trigger: 'blur' },
          {
            validator: this.floorEndRule,
            trigger: 'blur'
          }
        ],
        // requirementAreaStart: [{ validator: validateNumber, trigger: 'blur' }],
        // requirementAreaEnd: [{ validator: validateNumber, trigger: 'blur' }],
        // rentExpenseStart: [{ validator: validateNumber, trigger: 'blur' }],
        // rentExpenseEnd: [{ validator: validateNumber, trigger: 'blur' }],
        isCatering: [{ required: true, message: '请选择是否餐饮', trigger: 'blur' }]
        // alloweCateringTypeId: { required: true, message: '请选择', trigger: 'blur' }
        // isFrontage: { required: true, message: '请选择是否临街', trigger: 'blur' }
      },
      food: [
        { id: 0, title: '可轻餐' },
        { id: 1, title: '可重餐' }
      ],
      shopAncillaryArr: [], // 商铺配套-被选中
      trafficCrowdArr: [], // 客流人群-被选中
      customTags: [], // 自定义标签-被选中
      alternatePhone: {
        phone1: '',
        phone2: '',
        phone3: ''
      },
      isfood: false,
      isAlternatePhone: false,
      isExists: false,
      isRepeat: false,
      // district: [], // 区域
      businessDistrict: [], // 商圈
      StreetData: [], // 街道
      shopAncillaryOpts: [], // 商铺配套-字典
      trafficCrowdOpts: [], // 客流人群-字典
      consumeAncillaryOpts: [], // 消费配套
      customTagList: [], // 自定义标签-字典

      industryCategory: [], // 行业分类
      industrySubclass: [], // 经营行业（行业子类）

      // 状态数据字典
      isOptions: [],
      sexOptions: [],
      statusOptions: [],
      natureOptions: [],
      typeOptions: [],
      formTitle: '新增客源' // 标题
    };
  },
  methods: {
    // 初始化数据
    init() {
      // 区域列表
      this.getDistrict('addRentTourist', 'init');
      this.isFromDetails();
      // 查询房源自定义标签列表
      touristApi.houseCustomTagList({ rentSaleType: '1' }).then((res) => {
        if (res.code === 200) {
          this.customTagList = res.data;
          // console.log('查询房源自定义标签列表', this.customTagList)
        }
      });

      this.getDICTS();
      this.industryCategoryFn();
      console.log(this.form);
    },
    // 租金处理
    handleRental() {
      this.form.rentFeeCentiare = parseFloat(this.form.rentFee / this.form.grossFloorArea).toFixed(2);
      if (this.form.grossFloorArea) {
        this.form.rentFeeCentiare = parseFloat(this.form.rentFee / this.form.grossFloorArea).toFixed(2);
      }
    },

    goTouristDetail() {
      this.$router.push({
        path: '/tourist/details',
        query: {
          id: this.curRepeatLesseeInfoId
        }
      });
    },

    addPhone() {
      this.isAlternatePhone = true;
    },
    // 需求面积自定义验证操作
    requirementAreaEndRule(rule, value, callback) {
      if (this.form.requirementAreaStart * 1 > value * 1) {
        callback(new Error('面积填写请从小到大'));
      } else {
        callback();
      }
    },
    rentExpenseEndRule(rule, value, callback) {
      if (this.form.rentExpenseStart * 1 > value * 1) {
        callback(new Error('租金填写请从小到大'));
      } else {
        callback();
      }
    },
    //
    floorWideRule(rule, value, callback) {
      if (this.form.floorWideStart * 1 > this.form.floorWideEnd * 1) {
        callback(new Error('面宽填写请从小到大'));
      } else {
        callback();
      }
    },
    floorHighRule(rule, value, callback) {
      if (this.form.floorHighStart * 1 > this.form.floorHighEnd * 1) {
        callback(new Error('层高填写请从小到大'));
      } else {
        callback();
      }
    },
    floorLongRule(rule, value, callback) {
      if (this.form.floorLongStart * 1 > this.form.floorLongEnd * 1) {
        callback(new Error('进深填写请从小到大'));
      } else {
        callback();
      }
    },
    floorEndRule(rule, value, callback) {
      if (this.form.floorStart * 1 > this.form.floorEnd * 1) {
        callback(new Error('楼层填写请从小到大'));
      } else {
        callback();
      }
    },
    // 判断进入页面的路径
    isFromDetails() {
      if (this.$route.query.id >= 0) {
        this.formTitle = '编辑客源';
        this.getDataList();
      } else {
        this.formTitle = '新增客源';
      }
    },
    // 查询客户是否已存在
    async searchBtn(value) {
      const reg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
      if (value && !reg.test(value)) return;

      const params = {
        alternatePhone: '',
        id: this.form.lesseeInfoBo.id,
        lesseePhone: '',
        rentSaleType: '1'
      };
      this.phone();
      const { lesseePhone, alternatePhone } = this.form.lesseeInfoBo;
      if (!lesseePhone && !alternatePhone) {
        this.$message.warning('未填写信息');
      } else if (!lesseePhone) {
        this.$message.warning('未填写电话号码');
      } else {
        params.alternatePhone = alternatePhone;
        params.lesseePhone = lesseePhone;

        const res = await touristApi.existsSearch(params);
        if (res.code === 200) {
          this.isExists = res.data.isExists;
          if (this.isExists) {
            this.curRepeatPhone = lesseePhone;
            // this.curRepeatLesseeInfoId = res.data.lesseeInfoId
            this.curRepeatLesseeInfoId = res.data.requirementId; // 需求id
            this.phoneRepeatVisible = true;

            // this.$message.warning('手机号码已存在！')
            this.isRepeat = true;
          } else {
            this.$message.success('号码有效');
            this.isRepeat = false;
          }
        }
      }
    },

    // 返回
    reback() {
      this.$router.go(-1);
    },
    // 获取回显数据
    getDataList() {
      touristApi.touristDetails(Number(this.$route.query.id)).then((res) => {
        if (res.code === 200) {
          // console.log('获取回显数据', res.data)
          // 客户核心信息
          const { id, lesseeName, lesseePhone, lesseeWechat, lesseeSex, alternatePhone } = res.data.lesseeInfoVo;

          this.form.lesseeInfoBo.id = id;
          this.form.lesseeInfoBo.lesseeName = lesseeName;
          this.form.lesseeInfoBo.lesseePhone = lesseePhone;
          this.form.lesseeInfoBo.lesseeWechat = lesseeWechat;
          this.form.lesseeInfoBo.lesseeSex = lesseeSex || undefined;
          if (alternatePhone) {
            this.isAlternatePhone = true;
            if (alternatePhone.includes(',')) {
              const phoneList = alternatePhone.split(',');

              if (phoneList.length === 2) {
                this.alternatePhone.phone1 = phoneList[0];
                this.alternatePhone.phone2 = phoneList[1];
              }
              if (phoneList.length === 3) {
                this.alternatePhone.phone1 = phoneList[0];
                this.alternatePhone.phone2 = phoneList[1];
                this.alternatePhone.phone3 = phoneList[2];
              }
            } else {
              this.alternatePhone.phone1 = alternatePhone;
            }
          }

          // input框
          this.form.brandName = res.data.brandName;
          this.form.floorStart = res.data.floorStart ? res.data.floorStart : '';
          this.form.floorEnd = res.data.floorEnd ? res.data.floorEnd : '';
          this.form.requirementAreaStart = res.data.requirementAreaStart !== '0.00' ? res.data.requirementAreaStart : '';
          this.form.requirementAreaEnd = res.data.requirementAreaEnd !== '0.00' ? res.data.requirementAreaEnd : '';
          // this.form.floorWide = res.data.floorWide !== '0.00' ? res.data.floorWide : ''
          // this.form.floorHigh = res.data.floorHigh !== '0.00' ? res.data.floorHigh : ''
          // this.form.floorLong = res.data.floorLong !== '0.00' ? res.data.floorLong : ''
          this.form.floorWideStart = res.data.floorWideStart !== '0.00' ? res.data.floorWideStart : '';
          this.form.floorWideEnd = res.data.floorWideEnd !== '0.00' ? res.data.floorWideEnd : '';
          this.form.floorLongStart = res.data.floorLongStart !== '0.00' ? res.data.floorLongStart : '';
          this.form.floorLongEnd = res.data.floorLongEnd !== '0.00' ? res.data.floorLongEnd : '';
          this.form.floorHighStart = res.data.floorHighStart !== '0.00' ? res.data.floorHighStart : '';
          this.form.floorHighEnd = res.data.floorHighEnd !== '0.00' ? res.data.floorHighEnd : '';

          this.form.rentExpenseStart = res.data.rentExpenseStart !== '0.00' ? res.data.rentExpenseStart : '';
          this.form.rentExpenseEnd = res.data.rentExpenseEnd !== '0.00' ? res.data.rentExpenseEnd : '';
          this.form.electricPower = res.data.electricPower !== '0.00' ? res.data.electricPower : '';
          this.form.gasCapacity = res.data.gasCapacity !== '0.00' ? res.data.gasCapacity : '';
          this.form.otherInfo = res.data.otherInfo;
          // 下拉框
          this.form.industryCategoryName = res.data.industryCategoryName ? res.data.industryCategoryName : undefined;
          this.form.industrySubclassName = res.data.industrySubclassName ? res.data.industrySubclassName : undefined;
          this.form.industryCategoryId = res.data.industryCategoryId ? res.data.industryCategoryId : undefined;
          this.form.industrySubclassId = res.data.industrySubclassId ? res.data.industrySubclassId : undefined;
          this.industrySubclassFn(this.form.industryCategoryId);
          this.form.storeTypeId = res.data.storeTypeId ? res.data.storeTypeId : [];
          this.form.isFrontage = res.data.isFrontage ? res.data.isFrontage : undefined;
          this.form.shopNatureId = res.data.shopNatureId ? res.data.shopNatureId.toString() : undefined;
          this.form.operatingStateId = res.data.operatingStateId ? res.data.operatingStateId : undefined;
          // 隐藏是否餐饮
          // this.form.alloweCateringTypeId =
          //     res.data.alloweCateringTypeId == '3' ? undefined : res.data.alloweCateringTypeId

          this.form.districtName = res.data.districtName ? res.data.districtName : [];
          this.form.businessDistrictName = res.data.businessDistrictName ? res.data.businessDistrictName : [];
          this.form.streetName = res.data.streetName ? res.data.streetName : [];
          this.form.businessDistrictId = res.data.businessDistrictId ? res.data.businessDistrictId : [];
          this.form.districtId = res.data.districtId ? res.data.districtId : [];
          this.form.streetId = res.data.streetId ? res.data.streetId : [];
          this.form.isHaveTransferFee = res.data.isHaveTransferFee;
          // 隐藏是否餐饮
          // if (res.data.isCatering === 'Y') {
          //   this.form.isCatering = res.data.isCatering
          //   this.isfood = true
          // } else {
          //   this.form.isCatering = res.data.isCatering
          // }

          // 商铺配套
          this.shopAncillaryArr = res.data.shopAncillary ? res.data.shopAncillary.split(',') : [];
          // 客流人群
          this.trafficCrowdArr = res.data.trafficCrowd ? res.data.trafficCrowd.split(',') : [];
          // 自定义标签
          this.customTags = res.data.tagsContentArray ? res.data.tagsContentArray.split(',') : [];
          this.form.consumeAncillaryIds = res.data.consumeAncillaryIds || [];

          // 区域列表
          this.getDistrict('addRentTourist', 'init');
          this.streetListByIdsV2(this.form.businessDistrictId);
        }
      });
    },

    // 备用电话
    phone() {
      const a = this.alternatePhone.phone1;
      const b = this.alternatePhone.phone2;
      const c = this.alternatePhone.phone3;

      if (a && b && c) {
        this.form.lesseeInfoBo.alternatePhone = a + ',' + b + ',' + c;
      } else if (a && b) {
        this.form.lesseeInfoBo.alternatePhone = a + ',' + b;
      } else if (a && c) {
        this.form.lesseeInfoBo.alternatePhone = a + ',' + c;
      } else if (b && c) {
        this.form.lesseeInfoBo.alternatePhone = b + ',' + c;
      } else if (a) {
        this.form.lesseeInfoBo.alternatePhone = a;
      } else if (b) {
        this.form.lesseeInfoBo.alternatePhone = b;
      } else if (c) {
        this.form.lesseeInfoBo.alternatePhone = c;
      } else {
        this.form.lesseeInfoBo.alternatePhone = '';
      }
    },

    // 客源新增
    async addtourist() {
      // 商铺配套
      this.form.shopAncillary = this.shopAncillaryArr.join(',');
      // 客流人群
      this.form.trafficCrowd = this.trafficCrowdArr.join(',');
      // 自定义标签
      this.form.tagsContentArray = this.customTags.join(',');
      const fromObj = { ...this.form };
      Object.keys(fromObj).forEach((key) => {
        if (fromObj[key] === undefined) {
          fromObj[key] = '';
        }
      });
      if (fromObj.electricPower === '') fromObj.electricPower = 0;
      if (fromObj.gasCapacity === '') fromObj.gasCapacity = 0;
      if (fromObj.floorEnd === '') fromObj.floorEnd = 0;
      if (fromObj.floorStart === '') fromObj.floorStart = 0;
      // if (fromObj.floorWide === '') fromObj.floorWide = 0
      // if (fromObj.floorLong === '') fromObj.floorLong = 0
      // if (fromObj.floorHigh === '') fromObj.floorHigh = 0
      if (fromObj.floorWideStart === '') fromObj.floorWideStart = 0;
      if (fromObj.floorWideEnd === '') fromObj.floorWideEnd = 0;
      if (fromObj.floorLongStart === '') fromObj.floorLongStart = 0;
      if (fromObj.floorLongEnd === '') fromObj.floorLongEnd = 0;
      if (fromObj.floorHighStart === '') fromObj.floorHighStart = 0;
      if (fromObj.floorHighEnd === '') fromObj.floorHighEnd = 0;

      if (fromObj.rentExpenseStart === '') fromObj.rentExpenseStart = 0;
      if (fromObj.rentExpenseEnd === '') fromObj.rentExpenseEnd = 0;
      if (fromObj.requirementAreaStart === '') fromObj.requirementAreaStart = 0;
      if (fromObj.requirementAreaEnd === '') fromObj.requirementAreaEnd = 0;
      if (fromObj.lesseeInfoBo.lesseeSex === undefined) {
        fromObj.lesseeInfoBo.lesseeSex = '';
      }
      const validateFn1 = () => {
        let boolean;
        this.$refs.ruleForm.$refs.ruleForm.validate((valid) => {
          console.log(valid, 'valid');
          boolean = valid;
        });
        return boolean;
      };
      const validateFn2 = () => {
        let boolean;
        this.$refs.ruleForm2.validate((valid) => {
          boolean = valid;
        });
        return boolean;
      };
      if (validateFn1() && validateFn2()) {
        if (this.$route.query.id >= 0) {
          fromObj.id = Number(this.$route.query.id);
          fromObj.channelResource = '1';

          touristApi.touristPut(fromObj).then((res) => {
            if (res.code === 200) {
              this.$message.success('修改客源信息成功');
              this.saveType = true;
              this.$router.go(-1);
            }
          });
        } else {
          fromObj.channelResource = '1';
          // console.log(JSON.stringify(fromObj))
          touristApi.touristAdd(fromObj).then((res) => {
            if (res.code === 200) {
              this.saveType = true;
              this.$message.success('新增客源信息成功');
              this.$router.go(-1);
            }
          });
        }
      } else {
        console.log(validateFn1(), validateFn2());
        this.$message.error('未填写完整 ');
      }
    },
    // int验证
    intValidate(fieldName) {
      const val = this.form[fieldName];
      // const reg = /^[0-9]{1,6}$/
      const reg = /^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/;
      if (val) {
        const idx = val.indexOf('.');
        // console.log(val,idx, '88', reg, fieldName)
        if (idx > 0) {
          this.form[fieldName] = val;
        } else if (idx < 0) {
          if (reg.test(val)) {
            if (!isNaN(val)) {
              this.form[fieldName] = parseInt(val);
            }
          } else {
            this.$message.error('只能输入最多保留两位小数的数字');
            // this.form[fieldName] = ''
          }
        }
      }
    },
    consumeAncillaryChange(val) {
      if (!val) return;
      if (val.length > 4) {
        val = val.splice(0, 4);
        this.$message.error('消费配套最多只能选4个，请慎重选择');
      }
      this.form.consumeAncillaryIds = val;
      const NAMELIST = [];
      const LIST = this.consumeAncillaryOpts.filter((item) => {
        return val.indexOf(item.dictValue) > -1;
      });
      for (const obj of LIST) {
        NAMELIST.push(obj.dictLabel);
      }
      this.form.consumeAncillary = NAMELIST.join(',');
      this.$forceUpdate();
    },

    // 获取行业分类（行业大类）
    industryCategoryFn() {
      const params = {
        industryCategoryType: 1 // 行业类型（1：行业分类（行业大类） 2：经营行业（行业小类））
      };
      touristApi.industryCategory(params).then((res) => {
        if (res.code === 200) {
          this.industryCategory = res.data;
        }
      });
    },
    // 获取行业id获取行业名字
    getIndustryCategoryName(val) {
      for (const d of this.industryCategory) {
        if (d.id === val) {
          this.form.industryCategoryName = d.industryCategoryName;
          this.industrySubclassFn(val);
        }
      }
    },
    // 获取行业分类（行业小类）
    industrySubclassFn(val) {
      const params = {
        industryCategoryType: 2, // 行业类型（1：行业分类（行业大类） 2：经营行业（行业小类））
        parentId: val
      };
      touristApi.industryCategory(params).then((res) => {
        if (res.code === 200) {
          this.industrySubclass = res.data;
        }
      });
    },
    // 获取行业id获取行业名字
    getIndustrySubclassName(val) {
      for (const d of this.industrySubclass) {
        if (d.id === val) {
          this.form.industrySubclassName = d.industryCategoryName;
        }
      }
    },
    /**
     * @description:
     * @param {*} input 输入值
     * @param {*} option 下拉节点
     * @return {*}
     * @Author: wangZhan
     */
    filterOption(input, option) {
      // console.log(option,'option')
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
    },
    /**
     * 获取商圈
     * @param val
     */
    regionChangeV2(val) {
      locationApi.businessDistrictListByIdsV2({ ids: val }).then((res) => {
        this.businessDistrict = res.data;
        this.form.businessDistrictId = [];
        this.StreetData = [];
        this.form.streetId = [];
      });
    },
    businessDistrictMethodV2(val) {
      locationApi.streetListByIdsV2({ ids: val }).then((res) => {
        this.StreetData = res.data;
        this.form.streetId = [];
      });
    },
    streetListByIdsV2(val) {
      locationApi.streetListByIdsV2({ ids: val }).then((res) => {
        this.StreetData = res.data;
      });
    },

    // 字典表查询
    getDICTS() {
      this.getDicts('sys_yes_no').then((response) => {
        this.isOptions = response.data;
        // console.log('sys_yes_no', this.isOptions)
      });
      this.getDicts('sys_user_sex').then((response) => {
        this.sexOptions = response.data;
        // console.log(this.sexOptions)
      });
      this.getDicts('operating_status').then((response) => {
        this.statusOptions = response.data;
        // console.log(this.statusOptions)
      });
      this.getDicts('shop_nature').then((response) => {
        this.natureOptions = response.data;
        // console.log(this.natureOptions)
      });
      this.getDicts('shop_type').then((response) => {
        this.typeOptions = response.data;
        // console.log('需求商铺类型', this.typeOptions)
      });
      this.getDicts('repast_type').then((response) => {
        this.food = response.data.filter((v) => {
          return Number(v.dictValue) !== 3;
        });
        // console.log('repast_type', this.food)
      });
      this.getDicts('shop_ancillary').then((response) => {
        this.shopAncillaryOpts = response.data;
        // console.log(this.shopAncillaryOpts)
      });
      // 消费配套
      this.getDicts('consume_ancillary').then((response) => {
        this.consumeAncillaryOpts = response.data;
      });

      this.getDicts('traffic_crowd').then((response) => {
        this.trafficCrowdOpts = response.data;
        // console.log(this.trafficCrowdOpts)
      });
    }
  },

  created() {
    // this.init()
  },
  activated() {
    const storage = sessionStorage.getItem('history');
    console.log(storage, 'storage');
    let data = {};
    if (storage) {
      data = JSON.parse(storage);
      if (data.fromPage === 'add') {
        // this.resetForm()
        // this.lessorInfoBoList = []

        Object.keys(this.form).forEach((el) => {
          if (Array.isArray(this.form[el])) {
            this.form[el] = [];
          } else if (Object.prototype.toString.call(this.form[el]) === '[object Object]') {
            this.form[el] = {};
          } else {
            this.form[el] = null;
          }
        });
        this.form.lesseeInfoBo = {
          alternatePhone: '', // 备用手机号（最多三个），逗号隔开
          lesseeName: '',
          lesseePhone: '',
          lesseeSex: undefined,
          lesseeWechat: '',
          id: '',
          rentSaleType: '1'
        };
        this.alternatePhone = {
          phone1: '',
          phone2: '',
          phone3: ''
        };
      }
      this.init();
    }
  },
  deactivated() {
    sessionStorage.removeItem('history');
  },
  mounted() {}
};
</script>

<style lang="less" scoped>
.add {
  height: 100%;
  padding: 20px;
  border-radius: 15px;
  background-color: white;

  .title {
    display: flex;
    align-items: center;

    .name {
      margin-bottom: 0px;
      font-size: 20px;
      font-weight: bold;
      color: #000;
    }
  }

  .content {
    padding: 10px 40px;
    margin-bottom: 10px;

    .mr30 {
      margin-right: 30px;
    }

    .label {
      font-size: 18px;
      margin: 20px 0;
    }

    .textarea {
      width: 90%;
      height: 200px;
      outline: none;
      border-radius: 10px;
      border-color: #f1f2f3;
      padding: 10px;
      margin-bottom: 40px;
      resize: none;
      overflow: hidden;
    }

    .label-input {
      label {
        margin-right: 10px;
      }

      input {
        width: 60px;
        border: 1px solid #d9d9d9;
        outline: none;
        height: 16px;
        margin-right: 20px;
      }
    }

    /deep/ .ant-form-item-no-colon {
      color: #666;
      font-size: 16px;
    }
  }

  .el_button {
    background-color: var(--ThemeColor);
    color: white;
    width: 100px;
    height: 40px;

    &:hover {
      color: #fff;
    }
  }
}

.touristBtn:hover {
  color: #fff !important;
}

.w80 {
  width: 80px;
}

.w120 {
  width: 120px;
}

.w95 {
  width: 95px;
}

.w150 {
  width: 150px;
}

.w180 {
  width: 180px;
}

.w200 {
  width: 200px;
}

labelCol {
  width: 150px;
}
</style>
